import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/store';
import { AdminProfileState, ADMIN_PROFILE_SLICE_NAME } from './models';

export const adminProfileSelector = (state: RootState): AdminProfileState => state[ADMIN_PROFILE_SLICE_NAME];

export const selectAuthIsLoading = createSelector(adminProfileSelector, (state: AdminProfileState) => state.isLoading);

export const selectAdminProfile = createSelector(adminProfileSelector, (state: AdminProfileState) => state.profile);

export const selectAdminProfileError = createSelector(adminProfileSelector, (state: AdminProfileState) => state.error);
